import { IRenameProject } from '@/interfaces/storageTracking/IRenameProject.ts';
import { ICompanyRoleDate } from '@/interfaces/storageTracking/ICompanyRoleDate.ts';
import { IStatusDate } from '@/interfaces/storageTracking/IStatusDate.ts';
import { IValueStream } from '@/interfaces/storageTracking/IValueStream.ts';
import { IDataValidations } from '@/interfaces/storageTracking/IDataValidations.ts';
import { useApi } from '../useApi.ts';

const apiCall = useApi('storageTracking');

async function deleteProjects (factStorageIdsToDelete: string[]): Promise<string> {
    return (await apiCall.post<string[], string>({ endpoint: '/editData/deleteProjects', payload: factStorageIdsToDelete })).data;
}

async function renameProject (renameProjectItem: IRenameProject): Promise<string> {
    return (await apiCall.post<IRenameProject, string>({ endpoint: '/editData/renameProject', payload: renameProjectItem })).data;
}

async function deleteCompanyRole (companyRole: ICompanyRoleDate[]): Promise<string> {
    return (await apiCall.post<ICompanyRoleDate[], string>({ endpoint: '/editData/deleteCompanyRole', payload: companyRole })).data;
}

async function deleteStatus (status: IStatusDate[]): Promise<string> {
    return (await apiCall.post<IStatusDate[], string>({ endpoint: '/editData/deleteStatus', payload: status })).data;
}

async function deleteValueStream (valueStream: IValueStream): Promise<string> {
    return (await apiCall.post<IValueStream[], string>({ endpoint: '/editData/deleteValueStream', payload: [valueStream] })).data;
}

async function refreshDbData (): Promise<string> {
    return (await apiCall.get<string>({ endpoint: '/editData/refreshDbData' })).data;
}

async function getDataValidations (): Promise<IDataValidations> {
    return (await apiCall.get<IDataValidations>({ endpoint: '/editData/GetDataValidations' })).data;
}

export const editDataApi = {
    deleteCompanyRole,
    deleteProjects,
    deleteStatus,
    deleteValueStream,
    getDataValidations,
    refreshDbData,
    renameProject,
};
